import { Link } from "gatsby"
import React from "react"
import * as style from "./style.module.css"

const Component = ({ inLink, outLink, text, customColor, customFontSize }) => {
  let element = null
  const customStyle = {
    color: customColor,
    fontSize: customFontSize,
  }

  if (inLink) {
    element = (
      <Link className={style.customButton} style={customStyle} to={inLink}>
        {text}
      </Link>
    )
  } else if (outLink) {
    element = (
      <a
        className={style.customButton}
        style={customStyle}
        href={outLink}
        target="_blank"
        rel="noopener noreferrer"
      >
        {text}
      </a>
    )
  }

  return element
}

export default Component
